import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from '../admin/admin.service';

@Component({
  selector: 'app-add-admin',
  templateUrl: './add-admin.component.html',
  styleUrls: ['./add-admin.component.sass']
})
export class AddAdminComponent implements OnInit {
  accessList = [
    { id: '1',  label: 'User',   isChecked: false },
    { id: '2',  label: 'Driver',   isChecked: false },
    { id: '3',  label: 'Vehicles',   isChecked: false },
    { id: '4',  label: 'Packages',   isChecked: false },
    { id: '5',  label: 'Cities',   isChecked: false },
    { id: '6',  label: 'Admin',   isChecked: false },
    { id: '7',  label: 'Requets',   isChecked: false },  
  ]

  accessName:any;
  adminName="";
  adminPassword="";
  adminType="";
  constructor(private router:Router,
              private toastr:ToastrService,
              private spinner:NgxSpinnerService,
              private adminService:AdminService) { }

  ngOnInit(): void {
  }



  addAdmin(){
      this.spinner.show();
      let data = {
        "userName" : this.adminName,
        "password" : this.adminPassword,
        "adminType" : this.adminType,
        "active" :  1,
      }
      this.adminService.addAdmin(data).subscribe((result:any)=>{
        if(result.statusCode == 200){
          this.spinner.hide()
          this.toastr.success(result.message);
          this.adminName ="";
          this.adminPassword = "";
          this.adminType="";
          this.router.navigateByUrl('dashboard/admin');
        }else{
          this.spinner.hide()
          this.toastr.error(result.message);
          this.adminName ="";
          this.adminPassword = "";
          this.adminType="";
        }
      })
    }

    
    changeSelection(value:any  , isSelect:any){
      console.log(value)
      console.log(isSelect)
      if(isSelect == true){
        for(let i=0; i<this.accessList.length; i++){
          if(this.accessList[i].label == value){
            this.accessList[i].isChecked = true
          }
        }
      }else{
        for(let i=0; i<this.accessList.length; i++){
          if(this.accessList[i].label == value){
            this.accessList[i].isChecked = false
          }
        }
      }
      console.log(this.accessList)
    }




}
